import * as docketPropTypes from "../docketPropTypes";
import Dialog from "./mui/Dialog";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
	body: {
		paddingTop: 12,
		paddingLeft: 16,
		paddingRight: 16,
		paddingBottom: 0,
	},
});

export default class StyledDialog extends PureComponent {
	static propTypes = {
		aStylesBody: docketPropTypes.aphroditeStyles,
		aStylesContent: docketPropTypes.aphroditeStyles,
	};

	render() {
		return (
			<Dialog
				{...this.props}
				bodyClassName={css(styles.body, this.props.aStylesBody)}
				contentClassName={css(this.props.aStylesContent)}
			/>
		);
	}
}
